"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _default = (0, _createReactClass.default)({
  displayName: "ToggleButton",
  propTypes: {
    active: _propTypes.default.bool,
    children: _propTypes.default.node,
    className: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    icon: _UIIcon.default.propTypes.name,
    iconStyle: _propTypes.default.object,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    tooltip: _propTypes.default.node.isRequired,
    tooltipPlacement: _propTypes.default.string.isRequired
  },
  mixins: [_reactAddonsPureRenderMixin.default],
  getDefaultProps: function getDefaultProps() {
    return {
      active: false,
      disabled: false,
      label: '',
      icon: null,
      iconStyle: {},
      onClick: _emptyFunction.default,
      tooltip: '',
      tooltipPlacement: 'top'
    };
  },
  renderLabel: function renderLabel() {
    var _this$props = this.props,
        icon = _this$props.icon,
        iconStyle = _this$props.iconStyle,
        label = _this$props.label;

    if (icon !== null) {
      return _react.default.createElement(_UIIcon.default, {
        name: icon,
        style: iconStyle
      });
    }

    return label;
  },
  render: function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        onClick = _this$props2.onClick,
        tooltip = _this$props2.tooltip,
        tooltipPlacement = _this$props2.tooltipPlacement;
    var classes = (0, _classnames.default)(className, {
      active: active
    });
    return _react.default.createElement(_UITooltip.default, {
      disabled: !tooltip,
      placement: tooltipPlacement,
      title: tooltip
    }, _react.default.createElement(_UIButton.default, {
      className: classes,
      disabled: disabled,
      onClick: onClick,
      use: "unstyled"
    }, children, this.renderLabel()));
  }
});

exports.default = _default;
module.exports = exports.default;